import { ApiCore } from "."

export default new class {
    get(property: string) {
        return ApiCore.getJson('user_properties', { property })
    }

    set(property: string, propertyValue: string) {
        return ApiCore.postJson('user_properties', {
            property, property_value: propertyValue
        })
    }
}